module.exports = __webpack_public_path__ + "static/media/Full_insurance_image.e90fc966.png";